export default __webpack_public_path__ + "static/media/catalogHelper.0011f1a8.png";